import SiteFooter from '../components/footer/SiteFooter';
import { tr } from '../i18n/text';
import React from "react";
import Embrapa_inova from "../img/icone_pecuaria.svg";
import Tecnico from "../img/tecnico_transp.svg";
import Background from "../img/background_white.svg";
import { Button } from "../components/button/button";
import { useNavigate } from "react-router-dom";
import { hasAcceptedCurrentTerms } from '../utils/termsConsent';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/language/LanguageSwitcher';


function Boas_vindas() {
  const { t } = useTranslation(['onboarding', 'common']);
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (!hasAcceptedCurrentTerms()) {
      navigate('/termos');
      return;
    }

    navigate("/tec_pec");
  };

  return (
    <main className="onboarding-page onboarding-page--welcome">
      <header className="onboarding-brand onboarding-brand--welcome onboarding-brand--with-language">
        <img
          src={Embrapa_inova}
          alt={t("common:logoAlt")}
          fetchPriority="high"
          decoding="async"
          className="onboarding-brand__logo"
        />
        <LanguageSwitcher />
      </header>

      <div className="welcome-layout">
        <div className="welcome-visual" aria-hidden="true">
          <img src={Background} alt="" className="welcome-visual__background" />
          <img src={Tecnico} alt="" className="welcome-visual__person" />
        </div>

        <section className="welcome-copy" aria-labelledby="welcome-title">
          <h1 id="welcome-title">{t("welcome.title")}</h1>
          <p>{t("welcome.description")}</p>
          <Button texto={t("common:actions.next")} props_style="primary" onClick={handleSubmit} className="welcome-copy__action" />
        </section>
      </div>

      <SiteFooter className="onboarding-footer" />
    </main>
  );
}

export default Boas_vindas;
